import React from "react";
import Skeleton from "./Skeleton";
import "./PageSkeleton.scss";

interface PageSkeletonProps {
  // Number of card placeholders under the hero (matches the grid the real
  // page will render, so nothing jumps in height once it swaps in).
  cards?: number;
}

const PageSkeleton: React.FC<PageSkeletonProps> = ({ cards = 4 }) => (
  <div className="page-skeleton" aria-busy="true" aria-label="Loading page">
    <Skeleton className="page-skeleton-header" />
    <Skeleton className="page-skeleton-hero" />
    <div className="page-skeleton-row">
      {Array.from({ length: cards }).map((_, index) => (
        <Skeleton className="page-skeleton-card" key={index} />
      ))}
    </div>
  </div>
);

export default PageSkeleton;
